var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var ShapeWrapperInteractionView = require("./../../shapeWrapperViewer/shapeWrapperInteractionView.js");

var GlueInteractionView = function (editorView, interactionModel, parentGroup, layers) {
    ShapeWrapperInteractionView.apply(this, arguments);
};
lib_core.inherit(GlueInteractionView, ShapeWrapperInteractionView);

module.exports = GlueInteractionView;

GlueInteractionView.prototype.getLayers = function () {
    if(this.data.layerIndex.contains(0) &&
        (this.editorModel.visibleLayers.contains(0) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.TOP))) {
        console.assert(this.layers.glueTop && this.layers.glueTopControl, "Missing layers");

        return {
            draw: this.layers.glueTop,
            control: this.layers.glueTopControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
    else if(this.data.layerIndex.contains(1) &&
        (this.editorModel.visibleLayers.contains(1) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.BOTTOM))){
        console.assert(this.layers.glueBottom && this.layers.glueBottomControl, "Missing layers");

        return {
            draw: this.layers.glueBottom,
            control: this.layers.glueBottomControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
}
